module.exports = __webpack_public_path__ + "static/media/Filter.b378531a.svg";